(async function () {
  var urlObj = new URL(window.location.href);
  var params = new URLSearchParams(urlObj.search);
  const action = params.get('action');
  if (action !== 'view_portal_page') return console.log('view_portal_page action not found');

  const originalFetch = fetch;
  window.fetch = async (url, options) => {
    try {
      var urlObj = new URL(url);
      var params = new URLSearchParams(urlObj.search);
      const subscriptionId = params.get('subscription_id');
      if (params.get('action') === 'view_portal_page' && subscriptionId && url.includes('/recurring/quick_actions/')) {
        window.location.href = `https://myaccount.welcometobob.com/pages/8cfdfe48-f906-45d6-8515-29818e34a6d4/subscriptions/${subscriptionId}`;
        return true;
      }
      return originalFetch(url, options);
    } catch (error) {
      console.log('Error fetching url', error);
      return originalFetch(url, options);
    }
  };
})();
